<template>
    <div class="basePrice public_Spacing base-price-page">
        <div class="basePrice_title base-price-filter-card">
            <div class="base-price-section-head">
                <div>
                    <div class="base-price-section-title">筛选条件</div>
                    <div class="base-price-section-subtitle">按厂家查询底价、政策和等级单价信息</div>
                </div>
            </div>
            <div class="base-price-filter-row">
                <div class="public_oparetionBlock_Menu">
                <label class="public_lbSty">厂家：</label>
                <el-select class="public_optionSty dropDown_Define" filterable remote :remote-method="filterEidEnterprise" clearable v-model="enterpriseTwo"
                    placeholder="请选择">
                    <el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID" :label="item.SETTB99CA00"
                        :value="item.SETTB99ID">
                    </el-option>
                </el-select>
                </div>
                <div class="public_operatBtn base-price-actions">
                    <el-button type="primary" @click="queryClick">查询</el-button>
                </div>
            </div>
        </div>
        <div class="base-price-list-card">
            <div class="base-price-table-head">
                <div>
                    <div class="base-price-section-title">厂家底价列表</div>
                    <div class="base-price-section-subtitle">当前共 {{ count }} 条记录，关闭编辑开关后自动保存</div>
                </div>
            </div>
            <!-- 表格 -->
            <div class="table_content">
            <div class="box" v-for="(item, index) in millList" :key="index">
                <div class="box_content">
                    <!-- 前两列当成一个盒子 -->
                    <div class="box1">
                        <!-- 第一行,遍历所有行 -->
                        <!-- 表头 -->
                        <div class="box1_hang1" style="height: 31px;">
                            <div class="box1_hang1_left header_height" style="height: 31px;"><span class="header_title"
                                    style="margin-right: 10px;">编辑开关</span><el-switch v-model="item.edit"
                                    active-color="#178bff" @change="getSwithValue($event, item)">
                                </el-switch></div>
                            <div class="box1_hang1_right header_title header_height" style="height: 31px;">厂家基本信息</div>
                        </div>
                        <!-- 表体,遍历数组 -->
                        <div class="box1_hang1">
                            <div class="box1_hang1_left box1_hang1_left_title"><span class="space_box"></span>厂家</div>
                            <div class="box1_hang1_right">{{ item.ORMTB805CA03 }}</div>
                        </div>
                        <div class="box1_hang1">
                            <div class="box1_hang1_left box1_hang1_left_title"><span class="space_box"></span>户名</div>
                            <div class="box1_hang1_right">{{ item.ORMTB805CA01 }}</div>
                        </div>
                        <div class="box1_hang1">
                            <div class="box1_hang1_left box1_hang1_left_title"><span class="space_box"></span>厂家政策(元)
                            </div>
                            <div class="box1_hang1_right">
                                <el-input class="box1_hang1_right_input" v-model="item.ORMTB805CA06"
                                    :disabled="!item.edit"></el-input>
                            </div>
                        </div>
                        <div class="box1_hang1">
                            <div class="box1_hang1_left box1_hang1_left_title"><span class="space_box"></span>厂家开票税点
                            </div>
                            <div class="box1_hang1_right"><el-input class="box1_hang1_right_input"
                                    :disabled="!item.edit" v-model="item.ORMTB805CA07"></el-input></div>
                        </div>
                        <div class="box1_hang1">
                            <div class="box1_hang1_left box1_hang1_left_title"><span class="space_box"></span>税额</div>
                            <div class="box1_hang1_right"><el-input class="box1_hang1_right_input"
                                    :disabled="!item.edit" v-model="item.ORMTB805CA08"></el-input></div>
                        </div>
                        <div class="box1_hang1">
                            <div class="box1_hang1_left box1_hang1_left_title"><span class="space_box"></span>开票比例</div>
                            <div class="box1_hang1_right"><el-input class="box1_hang1_right_input"
                                    :disabled="!item.edit" v-model="item.ORMTB805CA09"></el-input></div>
                        </div>
                        <div class="box1_hang1_after">
                            <div class="last_line">
                                <span class="space_box"></span>
                                <span class="last_line_text">返点备注:</span>
                                <el-input class="last_line_textarea" type="textarea" resize="none" :autosize="{ minRows: 2, maxRows: 4 }" :disabled="!item.edit"
                                    v-model="item.ORMTB805CA010">
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <!-- 第二个盒子（第二列） -->
                    <div class="box3">
                        <!-- 表头 -->
                        <div class="box3_header header_title header_height">等级单价</div>
                        <!-- 表体 -->
                        <div class="box3_body">
                            <div class="box2_body_title">客户等级优惠</div>
                            <div class="box3_right">
                                <div class="box2_body_line1_left">
                                    <div class="box2_line1_left">单价</div>
                                    <div class="box2_line1_right">物料</div>
                                </div>
                                <!-- 等级列表 -->
                                <template v-if="item.levelList.length > 0">
                                    <div class="box3_name" v-for="(level, levelIndex) in item.levelList"
                                        :key="'l_' + levelIndex">
                                        {{ level }}</div>
                                </template>
                                <template v-else>
                                    <div class="box3_name" v-for="(level, levelIndex) in levelList"
                                        :key="'l_' + levelIndex">
                                        {{ level }}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <!-- 第三个盒子(第二列) -->
                    <div class="box2">
                        <!-- 表头 -->
                        <div class="box2_header">
                            <div class="box2_header_right header_title header_height">物料</div>
                        </div>
                        <!-- 竖盒子+表体 -->
                        <div class="box2_body">
                            <!-- 表体 -->
                            <div class="box2_body_content">
                                <!-- 第一列 -->
                                <div class="box2_body_line1">
                                    <div class="box2_body_line1_right">
                                        <!-- 物料列表 -->
                                        <div class="box2_right_item material_height"
                                            v-for="(material, materialIndex) in item.materialList"
                                            :key="'m_' + materialIndex">
                                            {{ material }}</div>
                                    </div>
                                </div>
                                <!-- 第二列及以下，底价遍历数组(前两列) -->
                                <div class="box2_body_line1" v-for="(base) in item.baseList" :key="base.id">
                                    <div class="box2_body_line1_right">
                                        <!-- 遍历以物料维度的数组，里面物料名和物料单价 -->
                                        <div class="box2_right_item" v-for="(baseItem) in base.child"
                                            :key="baseItem.id"><el-input class="box3_right_item_input"
                                                :disabled="!item.edit" v-model="baseItem.SETTB400CA05Price"
                                                @input="handleNumberInput(baseItem, $event)"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <!-- 等级数组(一级到十一级价格数据) -->
                                <div class="box2_body_line1" v-for="(data, dataIndex) in item.dataList"
                                    :key="dataIndex">
                                    <div class="box2_body_line1_right">
                                        <!-- 遍历以物料维度的数组，里面物料名和物料单价 -->
                                        <div class="box2_right_item" v-for="(dataItem, dataItemIndex) in data.child"
                                            :key="'b_' + dataItemIndex">{{ dataItem.SETTB400CA05Price }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <!-- 分页器 -->
            <div class="pulbic_pagesize">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                    layout="total,sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
export default {
  mixins: [enterpriseSearchMixin],
    data() {
        return {
            filteredEnterpriseOptions: [],
      enterpriseTwoOptionList: [],
            enterpriseTwo: '',
            currentPage: 1,
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            count: 0, //分页--数据列表共有的条数
            uobj: this.$store.state.uobj,
            millList: [],//厂家列表
            levelList: ['厂家底价(税)', '厂家底价(不含税)', '飞砂单价', '一级客户', '二级客户', '三级客户', '四级客户', '五级客户', '六级客户', '七级客户', '八级客户', '九级客户', '十级客户', '十一级客户'],
        }
    },
    created() {
        this.optionLists();
        this.pageList();
    },
    methods: {
        handleNumberInput(baseItem, value) {
            // 使用防抖避免频繁更新
            clearTimeout(this.inputTimer);
            this.inputTimer = setTimeout(() => {
                // 将各种形式的小数点统一为半角小数点
                let newValue = value
                    .replace(/[。．・･﹒•]/g, '.') // 各种全角、中文标点符号的小数点
                    .replace(/[^\d.]/g, ''); // 移除非数字和非小数点字符

                // 处理多个小数点
                const dotIndex = newValue.indexOf('.');
                if (dotIndex !== -1) {
                    const beforeDot = newValue.substring(0, dotIndex + 1);
                    const afterDot = newValue.substring(dotIndex + 1).replace(/\./g, '');
                    newValue = beforeDot + afterDot;
                }

                // 限制小数位
                if (newValue.includes('.')) {
                    const parts = newValue.split('.');
                    if (parts[1].length > 2) {
                        newValue = parts[0] + '.' + parts[1].substring(0, 2);
                    }
                }

                // 不能以小数点开头
                if (newValue.startsWith('.')) {
                    newValue = '0' + newValue;
                }

                baseItem.SETTB400CA05Price = newValue;
            }, 50);
        },
        getSwithValue(e, item) {
            if (!e) { // 开关关闭时，提交数据
                let arr1 = [];
                let arr2 = [];

                // 收集厂家底价(税)数据
                item.baseList[0].child.forEach((i, index) => {
                    let obj1 = {};
                    obj1.ORMTB806CA01 = i.settb109ID;
                    obj1.ORMTB806CA02 = i.SETTB400CA05Price;
                    // 添加其他必要字段
                    obj1.settb109ID = i.settb109ID;
                    obj1.settb109CA00 = i.settb109CA00;
                    arr1.push(obj1);
                })

                // 收集厂家底价(不含税)数据
                item.baseList[1].child.forEach((i, index) => {
                    let obj2 = {};
                    obj2.ORMTB806CA01 = i.settb109ID;
                    obj2.ORMTB806CA03 = i.SETTB400CA05Price;
                    // 添加其他必要字段
                    obj2.settb109ID = i.settb109ID;
                    obj2.settb109CA00 = i.settb109CA00;
                    arr2.push(obj2);
                })
                // 如果需要合并两个数组为一个
                let combinedArr = [];
                for (let i = 0; i < Math.max(arr1.length, arr2.length); i++) {
                    let combinedObj = {};
                    if (arr1[i]) {
                        combinedObj.ORMTB806CA01 = arr1[i].ORMTB806CA01;
                        combinedObj.ORMTB806CA02 = arr1[i].ORMTB806CA02;
                        combinedObj.settb109CA00 = arr1[i].settb109CA00;
                    }
                    if (arr2[i]) {
                        combinedObj.ORMTB806CA01 = combinedObj.ORMTB806CA01 || arr2[i].ORMTB806CA01;
                        combinedObj.ORMTB806CA03 = arr2[i].ORMTB806CA03;
                        combinedObj.settb109CA00 = combinedObj.settb109CA00 || arr2[i].settb109CA00;
                    }
                    if (Object.keys(combinedObj).length > 0) {
                        combinedArr.push(combinedObj);
                    }
                }

                let postData = {
                    ORMTB805ID: item.ORMTB805ID,
                    ORMTB805CA06: item.ORMTB805CA06 || '',
                    ORMTB805CA07: item.ORMTB805CA07 || '',
                    ORMTB805CA08: item.ORMTB805CA08 || '',
                    ORMTB805CA09: item.ORMTB805CA09 || '',
                    ORMTB805CA010: item.ORMTB805CA010 || '',
                    ormtb806List: combinedArr // 提交合并后的数据
                }
                this.submitBasePriceData(postData);
            }
        },

        // 提交数据的方法
        submitBasePriceData(postData) {
            let loading = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            });

            const url = '/ormtb805/editManuf';
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                        });
                        // 刷新数据
                        // this.pageList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        });
                    }
                    loading.close();
                })
                .catch(error => {
                    console.error('保存失败:', error);
                    this.$message({
                        message: '保存失败，请重试',
                        type: 'error',
                    });
                    loading.close();
                });
        },
        processRecords(records) {
            if (!records || records.length === 0) return [];

            var result = [];

            for (var i = 0; i < records.length; i++) {
                var record = records[i];
                var levelSet = new Set();
                var materialSet = new Set();
                var levelMap = new Map(); // 存储等级名称映射

                // 检查returnDataList是否存在
                if (!record.returnDataList) {
                    result.push({
                        ...record,
                        levelList: [],
                        materialList: [],
                        dataList: [],
                        baseList: []
                    });
                    continue;
                }

                // 收集等级和物料
                for (var j = 0; j < record.returnDataList.length; j++) {
                    var item = record.returnDataList[j];
                    if (item.settb109CA00) {
                        materialSet.add(item.settb109CA00);
                    }
                    if (item.maps) {
                        for (var k = 0; k < item.maps.length; k++) {
                            var mapItem = item.maps[k];
                            if (mapItem.SETTB400CA05Name) {
                                var displayName = `${mapItem.SETTB400CA05Name}(整车优惠${mapItem.SETTB400CA05zcyh}元)`;
                                levelSet.add(displayName);
                                // 存储原始名称和显示名称的映射
                                levelMap.set(displayName, mapItem.SETTB400CA05Name);
                            }
                        }
                    }
                }

                var levelList = Array.from(levelSet);
                var materialList = Array.from(materialSet);
                var dataList = [];

                // 构建dataList - 先添加飞砂单价
                // 飞砂单价作为第一个数据项
                var flySandItem = {
                    id: "fly_price",
                    SETTB400CA05zcyh: "",
                    SETTB400CA05Name: "飞砂单价",
                    SETTB400CA05Price: "",
                    SETTB400CA05zczk: "",
                    child: record.returnDataList.map(function (item, index) {
                        return {
                            settb109CA00: item.settb109CA00,
                            SETTB400CA05Price: item.settb109CA01.toString(),
                            id: "fly_" + index
                        };
                    })
                };
                dataList.push(flySandItem);

                // 然后添加其他等级数据
                for (var l = 0; l < levelList.length; l++) {
                    var displayLevelName = levelList[l]; // 显示名称
                    var originalLevelName = levelMap.get(displayLevelName); // 原始名称
                    var baseMap = {};
                    var child = [];

                    // 找到基础map信息（使用原始名称查找）
                    for (var m = 0; m < record.returnDataList[0].maps.length; m++) {
                        var map = record.returnDataList[0].maps[m];
                        if (map.SETTB400CA05Name === originalLevelName) {
                            baseMap = { ...map };
                            // 修改显示名称
                            baseMap.SETTB400CA05Name = displayLevelName;
                            break;
                        }
                    }

                    // 构建child数组（使用原始名称查找）
                    for (var n = 0; n < record.returnDataList.length; n++) {
                        var dataItem = record.returnDataList[n];
                        var SETTB400CA05Price = '0.0';
                        for (var o = 0; o < dataItem.maps.length; o++) {
                            var priceMap = dataItem.maps[o];
                            if (priceMap.SETTB400CA05Name === originalLevelName) {
                                SETTB400CA05Price = priceMap.SETTB400CA05Price;
                                break;
                            }
                        }
                        child.push({
                            settb109CA00: dataItem.settb109CA00,
                            SETTB400CA05Price: SETTB400CA05Price,
                            id: "level_" + l + "_" + n
                        });
                    }

                    baseMap.child = child;
                    baseMap.id = "level_" + l;
                    dataList.push(baseMap);
                }

                // 构建baseList - 只保留厂家底价(税)和厂家底价(不含税)
                var baseList = [
                    {
                        id: "tax_price",
                        SETTB400CA05zcyh: "",
                        SETTB400CA05Name: "厂家底价(税)",
                        SETTB400CA05Price: "",
                        SETTB400CA05zczk: "",
                        child: record.returnDataList.map(function (item, index) {
                            return {
                                settb109CA00: item.settb109CA00,
                                settb109ID: item.settb109ID,
                                SETTB400CA05Price: item.ormtb806CA02,
                                id: "tax_" + index
                            };
                        })
                    },
                    {
                        id: "notax_price",
                        SETTB400CA05zcyh: "",
                        SETTB400CA05Name: "厂家底价(不含税)",
                        SETTB400CA05Price: "",
                        SETTB400CA05zczk: "",
                        child: record.returnDataList.map(function (item, index) {
                            return {
                                settb109CA00: item.settb109CA00,
                                settb109ID: item.settb109ID,
                                SETTB400CA05Price: item.ormtb806CA03,
                                id: "notax_" + index
                            };
                        })
                    }
                ];

                // 更新levelList，包含飞砂单价和其他等级
                let initLevelList = ['厂家底价(税)', '厂家底价(不含税)', '飞砂单价'];
                let allLevelList = [...initLevelList, ...levelList];

                result.push({
                    ...record,
                    edit: false,
                    levelList: allLevelList,
                    materialList: materialList,
                    dataList: dataList,
                    baseList: baseList,
                });
            }

            return result;
        },
        queryClick() {
            this.pageList();
        },
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            const postData = {
                ORMTB400ID: this.uobj.ormtb400.ORMTB400ID,
                ORMTB805CA02: this.enterpriseTwo,
                page: this.pageMo,
                limit: this.limitMo,
            }

            this.millList = []
            const url = '/ormtb805/queryManuf'
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data.records;
                        this.millList = this.processRecords(data);
                        this.count = res.data.count
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    loading.close()
                })
                .catch(() => {
                    loading.close()
                })
        },
        optionLists() {
            this.loadEidByMaterial()
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
    }
}
</script>
<style scoped>
.basePrice {
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
}

.table_content {
    height: 650px;
    overflow-y: auto;
}

.box {
    display: inline-block;
    /* width: 100%; */
    /* overflow-x: auto; */
    border: 1px solid #ccc;
    margin: 0 40px 40px 0;
}

.box_content {
    display: flex;
}

.box1 {
    display: flex;
    flex-direction: column;
}

.box1_hang1 {
    display: flex;
}

.box1_hang1_left,
.box1_hang1_right {
    width: 201px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #ccc;
    padding: 4px 10px 0;
    box-sizing: border-box;
}

.box1_hang1_right_input {
    display: flex;
    align-items: center;
}

.box1_hang1_right_input /deep/.el-input__inner {
    text-align: center;
    height: 35px;
}

.box1_hang1_left_title {
    text-align: left;
    /* padding-left: 10px;
    box-sizing: border-box; */
}

.box1_hang1_after {
    flex: 0 0 auto;
    border: 1px solid #ccc;
}

.last_line {
    display: flex;
    width: 400px;
    height: 45px;
    line-height: 45px;
}

.last_line_text {
    width: 60px;
    border: none;
}

.last_line_textarea {
    flex: 1;
    padding-top: 10px;
    box-sizing: border-box;
}

/* 第二个盒子 */
.box2_header {
    display: flex;
    width: auto;
}

.box2_header_right {
    flex: 1;
    text-align: center;
    height: 45px;
    line-height: 45px;
    border: 1px solid #ccc;
}

.box2_header_left {
    width: 120px;
    text-align: center;
    height: 45px;
    line-height: 45px;
    border: 1px solid #ccc;
}

.box2_body {
    display: flex;
    align-items: center;
    max-width: 900px;
    overflow-x: auto;
}

.box2_body::-webkit-scrollbar {
    height: 6px;
}

.box2_body_line1 {
    display: flex;
}

/* .box2_body_line1:nth-last-child(1){
    height: 39px;
} */
.box2_body_line1:nth-last-child(1) .box2_body_line1_right .box2_right_item {
    height: 36px;
    line-height: 36px;
    /* background-color: red; */
}

.box2_body_title {
    display: flex;
    align-items: center;
    width: 20px;
    text-align: center;
    height: calc(100% + 15px);
    border-bottom: 2px solid #ccc;
}

.box2_line2_left {
    width: 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #ccc;
}

.box2_body_line1_right {
    display: flex;
}

.box2_right_item {
    width: 200px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #ccc;
    /* 单行省略号 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.material_height {
    height: 45px !important;
    line-height: 45px !important;
}

.box2_body_line1_left {
    position: relative;
    width: 180px;
    height: 45px;
    border: 1px solid #ccc;
}

.box2_body_line1_left::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom left, transparent 49%, #ccc 49%, #ccc 51%, transparent 51%);
}

.box2_line1_left {
    position: absolute;
    top: 15px;
    left: 20px;
}

.box2_line1_right {
    position: absolute;
    bottom: 15px;
    right: 20px;
}

/* box3 */
.box3_body {
    display: flex;
    height: calc(100% - 48px);
}

.box3_header {
    width: 203px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #ccc;
    border-right: none;
    border-left: none;
}

.box3_name {
    width: 181px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #ccc;
    border-left: none;
}

.box3_name:nth-last-child(1) {
    border-bottom: none;
    height: 36px;
    line-height: 40px;
}

/deep/.el-textarea__inner {
    border: 1px solid transparent !important;
}

.basePrice_title {
    display: flex;
    margin-bottom: 20px;
}

.public_lbSty {
    width: auto !important;
}

.header_title {
    font-size: 16px;
    font-weight: 700;
}

.header_height {
    display: flex;
    height: 30px;
    align-items: center;
    justify-content: center;
}

.space_box {
    display: inline-block;
    width: 20px;
}

.box3_right_item_input {
    display: flex;
    align-items: center;
    padding: 2px 5px 0;
    box-sizing: border-box;
}

.box3_right_item_input /deep/.el-input__inner {
    text-align: center;
    height: 26px;
    /* line-height: 24px; */
}

.box3_right {
    border-left: 1px solid #ccc;
    /* background-color: red; */
    height: calc(100% + 15px);
}


.basePrice {
    padding: 18px;
    min-height: calc(100vh - 132px);
    background: transparent;
    color: var(--fszs-text);
}

.basePrice_title {
    align-items: center;
    gap: 14px;
    margin-bottom: 16px;
    padding: 16px 18px;
    border: 1px solid rgba(220, 230, 242, 0.96);
    border-radius: var(--fszs-radius-lg);
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    box-shadow: var(--fszs-shadow-sm);
}

.basePrice_title .public_oparetionBlock_Menu {
    display: flex;
    align-items: center;
    margin: 0;
}

.basePrice_title .public_operatBtn {
    display: flex;
    align-items: center;
    margin-left: 0;
}

.basePrice .public_lbSty {
    color: var(--fszs-text-muted);
    font-weight: 600;
}


.table_content {
    height: calc(100vh - 235px);
    min-height: 520px;
    padding: 2px 4px 18px;
    overflow: auto;
}

.table_content::-webkit-scrollbar,
.box2_body::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.table_content::-webkit-scrollbar-thumb,
.box2_body::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(23, 139, 255, 0.22);
}

.table_content::-webkit-scrollbar-track,
.box2_body::-webkit-scrollbar-track {
    background: rgba(220, 230, 242, 0.36);
}

.box {
    display: block;
    width: max-content;
    min-width: 960px;
    margin: 0 0 20px;
    border: 1px solid rgba(220, 230, 242, 0.96);
    border-radius: var(--fszs-radius-lg);
    background: #ffffff;
    box-shadow: var(--fszs-shadow-sm);
    overflow: hidden;
}

.box_content {
    align-items: stretch;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
}

.box1 {
    flex: 0 0 auto;
    background: #ffffff;
}

.box1_hang1_left,
.box1_hang1_right,
.box1_hang1_after,
.box2_header_right,
.box2_header_left,
.box2_line2_left,
.box2_right_item,
.box2_body_line1_left,
.box3_header,
.box3_name {
    border-color: var(--fszs-border-soft);
}

.box1_hang1_left,
.box2_header_left,
.box2_line2_left,
.box2_body_title {
    color: var(--fszs-text-muted);
    background: #f8fbff;
    font-weight: 600;
}

.box1_hang1_right,
.box2_right_item,
.box3_name {
    color: var(--fszs-text);
    background: #ffffff;
}

.box1_hang1_left,
.box1_hang1_right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 184px;
    min-height: 42px;
    height: auto;
    line-height: 1.35;
    padding: 7px 10px;
}

.box1_hang1_right {
    overflow: visible;
    white-space: normal;
    word-break: break-all;
}

.box1_hang1_left_title {
    color: var(--fszs-text-muted);
}

.header_title {
    color: var(--fszs-text-strong);
    font-size: 15px;
    font-weight: 700;
    background: linear-gradient(180deg, #f4f9ff 0%, #edf6ff 100%);
}

.header_height {
    height: 34px;
    min-height: 34px;
}

.box1_hang1[style] {
    height: 34px !important;
}

.box1_hang1_left.header_height,
.box1_hang1_right.header_height {
    height: 34px !important;
    line-height: 34px;
}

.box1_hang1_after {
    background: #ffffff;
}

.last_line {
    display: flex;
    align-items: flex-start;
    width: 368px;
    height: auto;
    min-height: 74px;
    padding: 10px;
    line-height: 1.5;
    box-sizing: border-box;
}

.last_line_text {
    flex: 0 0 76px;
    width: 76px;
    padding-top: 7px;
    color: var(--fszs-text-muted);
    font-weight: 600;
}

.last_line_textarea {
    flex: 1;
    min-width: 0;
    padding-top: 0;
}

.basePrice /deep/.el-textarea__inner {
    max-height: 92px;
    overflow-y: auto;
    border: 1px solid var(--fszs-border-soft) !important;
    border-radius: 8px;
    background: #f8fbff;
}

.basePrice /deep/.el-textarea.is-disabled .el-textarea__inner,
.basePrice /deep/.el-input.is-disabled .el-input__inner {
    color: var(--fszs-text-muted);
    background: #f6f9fc;
    border-color: transparent;
}

.box1_hang1_right_input /deep/.el-input__inner,
.box3_right_item_input /deep/.el-input__inner {
    height: 28px;
    line-height: 28px;
    padding: 0 8px;
    border-radius: 7px;
    background: #f8fbff;
    color: var(--fszs-text-strong);
}

.box1_hang1_right_input /deep/.el-input__inner:focus,
.box3_right_item_input /deep/.el-input__inner:focus,
.basePrice /deep/.el-textarea__inner:focus {
    border-color: var(--fszs-primary) !important;
    background: #ffffff;
    box-shadow: var(--fszs-focus);
}

.box3_header {
    width: 186px;
    height: 34px;
    line-height: 34px;
}

.box3_body {
    height: calc(100% - 36px);
}

.box2_body_title {
    width: 34px;
    min-height: 100%;
    justify-content: center;
    border: 1px solid var(--fszs-border-soft);
    border-top: none;
    writing-mode: vertical-rl;
    letter-spacing: 2px;
}

.box3_right {
    height: auto;
    border-left-color: var(--fszs-border-soft);
}

.box2_body_line1_left {
    width: 150px;
    min-height: 42px;
    height: auto;
    background: #f8fbff;
}

.box2_body_line1_left::after {
    background: linear-gradient(to bottom left, transparent 49%, var(--fszs-border) 49%, var(--fszs-border) 51%, transparent 51%);
}

.box2_line1_left {
    top: 13px;
    left: 18px;
    color: var(--fszs-primary);
    font-weight: 700;
}

.box2_line1_right {
    right: 18px;
    bottom: 13px;
    color: var(--fszs-text-muted);
    font-weight: 600;
}

.box3_name {
    width: 151px;
    height: 31px;
    line-height: 31px;
    padding: 0 8px;
    box-sizing: border-box;
    text-align: left;
    color: var(--fszs-text-muted);
}

.box3_name:nth-last-child(1) {
    height: 34px;
    line-height: 34px;
}

.box2_header_right {
    height: 34px;
    line-height: 34px;
}

.box2_body {
    max-width: min(920px, calc(100vw - 650px));
    overflow: auto;
    background: #ffffff;
}

.box2_body_content {
    flex: 0 0 auto;
}

.box2_right_item {
    width: 176px;
    min-height: 31px;
    height: auto;
    line-height: 1.35;
    padding: 7px 8px;
    box-sizing: border-box;
    color: var(--fszs-text);
    white-space: normal;
    word-break: break-all;
}

.material_height {
    height: 42px !important;
    line-height: 42px !important;
    color: var(--fszs-text-strong);
    background: #f8fbff;
    font-weight: 700;
}

.box2_body_line1:nth-last-child(1) .box2_body_line1_right .box2_right_item {
    height: 34px;
    line-height: 34px;
}

.box3_right_item_input {
    height: 31px;
    padding: 2px 6px;
}

.basePrice .pulbic_pagesize {
    display: flex;
    justify-content: flex-end;
    margin-top: 0;
    padding: 12px 0 0;
}

.basePrice /deep/.el-switch__core {
    border-color: #c8d7e8;
    background: #c8d7e8;
}

.basePrice /deep/.el-switch.is-checked .el-switch__core {
    border-color: var(--fszs-primary);
    background: var(--fszs-primary);
}

@media screen and (max-width: 1440px) {
    .box2_body {
        max-width: 680px;
    }
}

@media screen and (max-width: 1180px) {
    .basePrice {
        padding: 12px;
    }

    .basePrice_title {
        flex-wrap: wrap;
        padding: 14px;
    }

    .table_content {
        height: calc(100vh - 220px);
        min-height: 460px;
    }

    .box2_body {
        max-width: 560px;
    }

}
.base-price-page {
    min-height: 100%;
    padding: 16px;
    background: #f4f8fc;
    box-sizing: border-box;
}

.base-price-filter-card,
.base-price-list-card {
    border: 1px solid #e3edf7;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(31, 93, 154, .08);
}

.base-price-filter-card {
    display: block;
    margin-bottom: 16px;
    padding: 18px 20px 16px;
}

.base-price-section-head,
.base-price-table-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.base-price-table-head {
    margin-top: 8px;
}

.base-price-section-title {
    position: relative;
    padding-left: 12px;
    color: #183b5b;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.2;
}

.base-price-section-title::before {
    position: absolute;
    top: 2px;
    left: 0;
    width: 4px;
    height: 18px;
    border-radius: 4px;
    background: #2689e8;
    content: '';
}

.base-price-section-subtitle {
    margin-top: 6px;
    padding-left: 12px;
    color: #7b8fa6;
    font-size: 13px;
}

.base-price-filter-row {
    display: flex;
    align-items: center;
    gap: 14px;
}

.base-price-page .public_oparetionBlock_Menu {
    display: flex;
    align-items: center;
    margin: 0;
}

.base-price-page .public_lbSty {
    min-width: 54px;
    color: #51687f;
    font-size: 14px;
    font-weight: 700;
    text-align: right;
}

.base-price-page .public_optionSty {
    width: 280px;
}

.base-price-page /deep/ .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-color: #d9e7f3;
    border-radius: 9px;
}

.base-price-page /deep/ .el-input__inner:focus {
    border-color: #2689e8;
}

.base-price-actions {
    display: flex;
    align-items: center;
    margin: 0 !important;
}

.base-price-actions /deep/ .el-button {
    min-width: 86px;
    height: 36px;
    padding: 0 18px;
    border: none;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 700;
    background: linear-gradient(135deg, #3aa0ff, #1976d2);
    box-shadow: 0 6px 14px rgba(38, 137, 232, .24);
}

.base-price-list-card {
    padding: 18px 20px 12px;
}

.base-price-list-card .table_content {
    height: auto;
    max-height: calc(100vh - 315px);
    min-height: 0;
    padding: 2px 4px 8px;
    overflow: auto;
}

.base-price-list-card .box {
    border-color: #d9e7f3;
    border-radius: 14px;
    box-shadow: 0 6px 18px rgba(31, 93, 154, .07);
}

.base-price-list-card .box_content {
    background: #fff;
}

.base-price-list-card .header_title {
    background: #f0f7ff;
    color: #24435f;
    font-size: 15px;
    font-weight: 800;
}

.base-price-list-card .box1_hang1_left,
.base-price-list-card .box2_header_left,
.base-price-list-card .box2_line2_left,
.base-price-list-card .box2_body_title,
.base-price-list-card .material_height {
    background: #f7fbff;
    color: #51687f;
    font-weight: 700;
}

.base-price-list-card .box1_hang1_right,
.base-price-list-card .box2_right_item,
.base-price-list-card .box3_name {
    color: #22384d;
}

.base-price-list-card .box1_hang1_left,
.base-price-list-card .box1_hang1_right,
.base-price-list-card .box1_hang1_after,
.base-price-list-card .box2_header_right,
.base-price-list-card .box2_header_left,
.base-price-list-card .box2_line2_left,
.base-price-list-card .box2_right_item,
.base-price-list-card .box2_body_line1_left,
.base-price-list-card .box3_header,
.base-price-list-card .box3_name {
    border-color: #d9e7f3;
}

.base-price-list-card /deep/ .el-textarea__inner,
.base-price-list-card /deep/ .el-input__inner {
    border-color: #d9e7f3;
    border-radius: 8px;
}

.base-price-list-card /deep/ .el-input.is-disabled .el-input__inner,
.base-price-list-card /deep/ .el-textarea.is-disabled .el-textarea__inner {
    border-color: transparent;
    background: #f6f9fc;
    color: #51687f;
}

.base-price-list-card .pulbic_pagesize {
    display: flex;
    justify-content: flex-end;
    padding-top: 14px;
}

.base-price-list-card .box2_body_line1_left {
    width: 230px;
    height: 46px;
}

.base-price-list-card .box3_header {
    width: 266px;
}

.base-price-list-card .box3_name {
    display: flex;
    align-items: center;
    width: 231px;
    min-height: 40px;
    height: auto;
    line-height: 1.35;
    white-space: normal;
    word-break: break-all;
}

.base-price-list-card .box2_right_item {
    min-height: 40px;
    height: auto;
    line-height: 40px;
}

.base-price-list-card .box3_right_item_input {
    min-height: 40px;
}

.base-price-list-card .box3_right_item_input /deep/ .el-input__inner {
    height: 32px;
}

.base-price-list-card .box3_name:nth-last-child(1) {
    border-bottom: 1px solid #d9e7f3;
}

.base-price-list-card .box2_body_line1:nth-last-child(1) .box2_body_line1_right .box2_right_item {
    min-height: 40px;
    height: auto;
    line-height: 40px;
    border-bottom: 1px solid #d9e7f3;
}

@media screen and (max-width: 1180px) {
    .base-price-filter-row {
        flex-wrap: wrap;
    }
}
</style>

